import { Button } from "@/03-presenters/components/ui/button";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { sendResetEmail } from "./sendVerificationCode.action";
import { UseFormSetError } from "react-hook-form";
import { z } from "zod";
import { credientialResetPwd } from "@/01-core/user/user";
export function ResetPwdEmailVerificationForm({
  email,
  setError
}: {
  email: string;
  setError: UseFormSetError<z.infer<typeof credientialResetPwd>>;
}) {
  const [pending, setPending] = useState(false);
  const [countDown, setCountDown] = useState(60);
  const [startCountDown, setStartCountDown] = useState(false);
  useEffect(() => {
    if (!startCountDown) {
      return;
    }
    const interval = setInterval(() => {
      setCountDown(preCount => {
        if (preCount <= 0) {
          setStartCountDown(false);
          clearInterval(interval);
          return 60;
        }
        return preCount - 1;
      });
    }, 1000);
    return () => {
      clearInterval(interval);
      setStartCountDown(false);
    };
  }, [startCountDown]);
  return <Button onClick={async () => {
    setPending(true);
    const err = await sendResetEmail(email);
    if (err) {
      setError("email", {
        message: err,
        type: "value"
      });
    } else {
      setStartCountDown(true);
    }
    setPending(false);
  }} className="border-primary text-primary" variant="outline" disabled={pending || startCountDown} data-sentry-element="Button" data-sentry-component="ResetPwdEmailVerificationForm" data-sentry-source-file="ResetPwdEmailVerificationForm.tsx">
      {startCountDown ? countDown + "s" : <span className="inline-flex items-center">
          获取验证码
          {pending ? <Loader2 className="ml-2 size-4 animate-spin" /> : <span>&rarr;</span>}
        </span>}
    </Button>;
}